/* heddz CRO preview layer. See snippets/heddz-cro.liquid for the summary.
   Reads the same live payload as heddz.js and cart-drawer.js; no prices are
   hardcoded here. Never touches the pricing engine directly: drawer changes
   go through /cart/add.js + /cart/change.js and then cartDrawer.refresh(). */
(function () {
  'use strict';
  var CRO = window.HeddzCRO || {};
  var busy = false;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function payload() {
    var el = $('script[data-buybox-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function money(c) {
    var s = (Math.round(c) / 100).toFixed(2);
    if (s.slice(-3) === '.00') s = s.slice(0, -3);
    return '$' + s;
  }

  function cents(v) {
    if (typeof v === 'number') return v;
    if (!v) return null;
    var n = parseFloat(String(v).split(',').join('').split('$').join(''));
    return isNaN(n) ? null : Math.round(n * 100);
  }

  function plan(p, role) {
    var prod = p && p.products && p.products[role];
    if (!prod || !prod.plans || !prod.plans.length) return null;
    var pl = prod.plans[0];
    var first = pl.firstCents != null ? pl.firstCents : cents(pl.firstMoney);
    var recur = pl.recurringCents != null ? pl.recurringCents : cents(pl.recurringMoney);
    if (recur == null) recur = first;
    var intro = first;
    if (!(pl.adjustments > 1)) {
      var i = p.intro || (window.Heddz && window.Heddz.intro);
      if (i && i.amountCents && first != null && (!i.roles || i.roles.indexOf(role) > -1)) intro = Math.max(0, first - i.amountCents);
    }
    return { id: pl.id, recur: recur, intro: intro, variantId: prod.variantId };
  }

  function podIds(p) {
    var ids = [];
    ['relief', 'calm', 'focus'].forEach(function (r) {
      var v = p && p.products && p.products[r] && p.products[r].variantId;
      if (v) ids.push(String(v));
    });
    return ids;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* ---------- social proof variant (split-testable) ---------- */

  function proofVariant() {
    var v = CRO.proof || 'customers';
    try {
      var q = new URLSearchParams(window.location.search).get('proof');
      if (q === 'customers' || q === 'reviews') { v = q; sessionStorage.setItem('heddzProof', q); }
      else if (sessionStorage.getItem('heddzProof')) v = sessionStorage.getItem('heddzProof');
    } catch (e) {}
    document.documentElement.setAttribute('data-proof', v);
    return v;
  }

  function proofHtml(v) {
    if (v === 'reviews' && CRO.reviewCount > 0) {
      return '<strong>' + Number(CRO.reviewAvg).toFixed(1) + '</strong> &middot; ' + CRO.reviewCount + ' verified reviews';
    }
    if (CRO.customers) return 'loved by <strong>' + Number(CRO.customers).toLocaleString('en-US') + '+</strong> customers';
    return null;
  }

  /* ---------- buy box ---------- */

  /* switch the buy box to the trio on subscribe & save, using heddz.js's own
     controls so its state, prices and CTA all update normally */
  function goTrioSub(box) {
    var tb = $('.tab[data-mode="bundle"]', box);
    if (tb) tb.click();
    var b = $('.bundle__btn[data-b="trio"]', box);
    if (b) b.click();
    var sub = $('[data-plan="sub"]', box);
    if (sub) sub.click();
    var target = $('[data-plans]', box) || box;
    var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  function buybox() {
    var p = payload();
    var proof = proofHtml(proofVariant());
    $$('[data-buybox]').forEach(function (box) {
      var tb = $('.tab[data-mode="bundle"]', box);
      var ts = $('.tab[data-mode="single"]', box);
      var single = p && p.products && p.products.relief ? p.products.relief.price : null;
      if (!CRO.onSix) {
        if (tb) tb.innerHTML = 'try all 3<small>the trio, best value</small>';
        if (ts) ts.innerHTML = 'pick one<small>' + (single ? money(single) + ' + shipping' : 'one scent') + '</small>';
      }
      var chip = $('.plan__chip', box);
      if (chip) chip.textContent = 'save 20%';
      var rt = $('.rating .rtxt', box);
      if (rt && proof) rt.innerHTML = proof;

      if (!p || $('.cro-nudge', box)) return;
      var sp = $('[data-single-price]', box);
      var tp = plan(p, 'trio');
      if (!sp || !single || !tp || tp.intro == null) return;

      /* savings on the first trio vs buying all three scents separately */
      var save = single * 3 - tp.intro;
      if (save <= 0) return;

      var n = document.createElement('div');
      n.className = 'cro-nudge';
      n.innerHTML = '<span class="cro-nudge__t"><b>save ' + money(save) + '</b> on your first order with the trio' +
        '<small>all 3 scents for ' + money(tp.intro) + ' on subscribe &amp; save, then ' + money(tp.recur) + '/mo. ships free, cancel anytime.</small>' +
        '</span><button type="button" class="cro-nudge__b">get the trio</button>';
      sp.parentNode.insertBefore(n, sp.nextSibling);
      $('.cro-nudge__b', n).addEventListener('click', function (e) {
        e.preventDefault();
        goTrioSub(box);
      });
    });

    if (CRO.reviewCount > 0) {
      $$('.hzrev__h2').forEach(function (h) {
        h.textContent = Number(CRO.reviewAvg).toFixed(1) + ' from ' + CRO.reviewCount + ' verified reviews.';
      });
    }
  }

  /* ---------- cart drawer ---------- */

  function sixCard(p, tp, dp) {
    var perTrio = tp.recur / 3, perSix = dp.recur / 6;
    return '<div class="hd-cd__up" data-cro-card>' +
      '<div class="hd-cd__up-k">double up</div>' +
      '<p class="hd-cd__up-h">6 pods every 2 months for ' + money(dp.recur) + '</p>' +
      '<p class="hd-cd__up-b">that is <b>' + money(perSix) + ' a pod</b> instead of ' + money(perTrio) + '. two of each scent, so one lives in your bag and one at home.</p>' +
      '<button type="button" class="hd-cd__up-btn" data-cro-six>switch to the six pack</button>' +
      '<p class="hd-cd__err" data-cro-err hidden></p>' +
      '<button type="button" class="cro-skip" data-cro-skip>no thanks, keep the trio</button>' +
    '</div>';
  }

  function patch(up, p) {
    if (busy || !p) return;

    var k = $('.hd-cd__up-k', up), h = $('.hd-cd__up-h', up);
    if (k && h && k.textContent === 'upgrade' && !h.getAttribute('data-cro')) {
      h.setAttribute('data-cro', '1');
      h.textContent = 'get all 3 scents instead';
      var tp0 = plan(p, 'trio');
      getCart().then(function (cart) {
        if (!tp0 || tp0.intro == null || !h.isConnected) return;
        var ids = podIds(p), pod = 0;
        (cart.items || []).forEach(function (it) { if (ids.indexOf(String(it.id)) > -1) pod = it.final_line_price; });
        var d = tp0.intro - pod;
        h.textContent = d > 0 ? 'all 3 scents for ' + money(d) + ' more, shipped free' : 'all 3 scents for less than your one pod';
      }).catch(function () {});
    }

    var won = $('.hd-cd__won', up);
    if (won && !window.__croSkipSix) {
      var tp = plan(p, 'trio'), dp = plan(p, 'double');
      if (!tp || !dp || !dp.variantId) return;
      getCart().then(function (cart) {
        var items = cart.items || [];
        var hasTrioSub = false, hasSix = false;
        items.forEach(function (it) {
          if (String(it.id) === String(tp.variantId) && it.selling_plan_allocation) hasTrioSub = true;
          if (String(it.id) === String(dp.variantId)) hasSix = true;
        });
        if (hasTrioSub && !hasSix && $('.hd-cd__won', up)) up.innerHTML = sixCard(p, tp, dp);
      }).catch(function () {});
    }
  }

  function drawer() {
    var up = $('[data-cd-upsell]');
    if (!up) return;
    var p = payload();
    new MutationObserver(function () { patch(up, p); }).observe(up, { childList: true });
    patch(up, p);

    document.addEventListener('click', function (e) {
      var skip = e.target.closest && e.target.closest('[data-cro-skip]');
      if (skip) {
        e.preventDefault();
        window.__croSkipSix = true;
        if (window.Heddz && window.Heddz.cartDrawer) window.Heddz.cartDrawer.refresh();
        return;
      }
      var btn = e.target.closest && e.target.closest('[data-cro-six]');
      if (!btn || busy) return;
      e.preventDefault();
      var tp = plan(p, 'trio'), dp = plan(p, 'double');
      var err = $('[data-cro-err]', up);
      busy = true;
      btn.disabled = true;
      btn.textContent = 'switching...';
      var addUrl = (window.Heddz && window.Heddz.routes && window.Heddz.routes.cartAdd) || '/cart/add.js';
      if (addUrl.indexOf('appstle') === -1) addUrl = '/cart/add.js?appstle=true';
      getCart().then(function (cart) {
        var trioKey = null;
        (cart.items || []).forEach(function (it) {
          if (String(it.id) === String(tp.variantId) && it.selling_plan_allocation) trioKey = it.key;
        });
        return post(addUrl, { items: [{ id: dp.variantId, quantity: 1, selling_plan: dp.id }] }).then(function () {
          if (trioKey) return post('/cart/change.js', { id: trioKey, quantity: 0 });
        });
      }).then(function () {
        busy = false;
        if (window.Heddz && window.Heddz.cartDrawer) return window.Heddz.cartDrawer.refresh();
      }).catch(function (x) {
        busy = false;
        btn.disabled = false;
        btn.textContent = 'switch to the six pack';
        if (err) { err.textContent = (x && (x.description || x.message)) || 'that did not go through. please try again.'; err.hidden = false; }
        if (window.Heddz && window.Heddz.cartDrawer) window.Heddz.cartDrawer.refresh();
      });
    });
  }

  function init() { buybox(); drawer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', buybox);
})();
